// extracted by mini-css-extract-plugin
export default {"font-renta":"Admin_font-renta__uSnwr","admin":"Admin_admin__Dh-q1","menu":"Admin_menu__8VhUc","menuLink":"Admin_menuLink__xMScY","active":"Admin_active__8U7-I"};